import { useCallback } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Card, Svg, Typography } from '@altermaind/web/ui';
import { useDialog } from '@/_shared/hooks/useDialog';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

export const NoCompanyData = () => {
  const t = useTranslations('people.noCompanyData');
  const { genericResponsiveValue } = useResponsiveStyle();
  const { openDialog: openAddEmployeeChoice } = useDialog('addEmployeeChoice');

  const goToImport = useCallback(() => {
    openAddEmployeeChoice();
  }, [openAddEmployeeChoice]);

  return (
    <Card>
      <Typography variant='h2' mb='xs'>
        {t('title')}
      </Typography>
      <Typography variant='p2/light' mb='m'>
        {t('description')}
      </Typography>
      <Box display='flex' flexDirection='row'>
        <Card
          display='flex'
          flexDirection={genericResponsiveValue({
            breakPoints: { desktop: 'row' },
            defaultValue: 'column',
          })}
          flex='1'
          backgroundColor='primary'
        >
          <Box mt='xxxxs' mr='xxs'>
            <Svg name='docsRar' size='s' />
          </Box>
          <Box flex='1'>
            <Typography variant='h4' mt='none'>
              {t('boxAlert.title')}
            </Typography>
            <Typography minHeight='48px' variant='p2/light' mt='xxxs'>
              {t('boxAlert.description')}
            </Typography>
          </Box>
          <Box flex='1' alignContent='flex-end'>
            <Box
              onClick={goToImport}
              display='flex'
              justifyContent={genericResponsiveValue({
                breakPoints: { desktop: 'flex-end' },
                defaultValue: 'flex-start',
              })}
            >
              <Button mt='s' variant='positive' data-testid='add-employee-no-data-button'>
                {t('boxAlert.buttonLabel')}
              </Button>
            </Box>
          </Box>
        </Card>
      </Box>
    </Card>
  );
};
